import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import { elsevierStyleSheetJSfileImport } from "../library/utils";
import axios from "axios";
import { backendBookartUrl } from "../library/constants";

const Account = () => {
  const [nav, setNav] = useState({ profile: true, address: false });
  const [shippingAddress, setShippingAddress] = useState([]);
  const [billingAddress, setBillingAddress] = useState([]);
  const [accountDetails, setAccountDetails] = useState({});
  const [auth, setAuth] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    authUser(); // Authenticate User
    elsevierStyleSheetJSfileImport();
    getCustomerProfile();
    getAddressDetails();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNav = (event) => {
    event.preventDefault();
    const name = event.target.name.toLowerCase();
    setNav({
      profile: name === "profile",
      address: name === "address",
    });
  };

  const authUser = async () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    if (token === null) {
      navigate("/");
    } else {
      setAuth(true);
    }
  };

  const getCustomerProfile = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    const config = {
      method: "post",
      url: `${backendBookartUrl}/accountdetails?=`,
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response) => {
        console.log("Account details response:", response.data);
        const accountDetails = response.data.account_details[0]; // Access the first account
        setAccountDetails(accountDetails); // Set the account details
      })
      .catch((error) => {
        if (error.response && error.response.data.msg === 'Token has expired') {
          navigate('/'); // Redirect if token is expired
        } else {
          console.log(error);
        }
      });
  };

  const getAddressDetails = () => {
    const token = window.sessionStorage.getItem("JWTtoken");
    const config = {
      method: "post",
      url: `${backendBookartUrl}/view_address_details?=`,
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response) => {
        const address = response.data.address;
        console.log("address", address);
        setShippingAddress(address.shipto_address || []);
        setBillingAddress(address.billto_address || []);
      })
      .catch((error) => {
        if (error.response && error.response.data.msg === 'Token has expired') {
          // Redirect to login page if the token has expired
          navigate('/');
        } else {
          console.log(error);
        }
      });
  };

  if (!auth) {
    return <div></div>;
  } else {
    return (
      <React.Fragment>
        <MainHeader />
        <div className="container">
          <section>
            <div className="margin-top-30">
              <Link className="es-link colored font-16" to="/home">
                <svg viewBox="0 0 54 128" height="16" width="11">
                  <path d="M1 61l45-45 7 7-38 38 38 38-7 7z"></path>
                </svg>
                &nbsp;Back to home
              </Link>
            </div>
            <h3 className="margin-top-30">Account Details</h3>
            <div className="row margin-top-30">
              <div className="col-3">
                <nav id="account-details">
                  <ol className="es-list none">
                    <li>
                      <button type="button"
                        className={
                          nav.profile ? "es-link selected pointer" : "es-link pointer"
                        }
                        name="profile"
                        onClick={handleNav}
                      >
                        Profile
                      </button>
                    </li>
                    <li>
                      <button type="button"
                        name="address"
                        className={
                          nav.address ? "es-link selected pointer" : "es-link pointer"
                        }
                        onClick={handleNav}
                      >
                        Address
                      </button>
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="col-9">
                <div id="profile" className={nav.profile ? "" : "collapse"}>
                  <h3>Profile</h3>
                  <div className="accountDetails">
                    {accountDetails.customer_name ? ( // Check if customer_name exists
                      <p>
                        <div className="font-18">
                          {accountDetails.customer_name}
                        </div>
                        <div className="font-14">
                          Account No: {accountDetails.account_number}
                        </div>
                        <div className="font-14">
                          Email: {accountDetails.email_address}
                        </div>
                      </p>
                    ) : (
                      <p>Loading account details...</p> // Show loading or placeholder text
                    )}
                    <div className="row font-14">
                      <div className="col-md-6">
                        <div>
                          <strong>Phone no: </strong>
                          {accountDetails.contact_number}
                        </div>
                        <div>
                          <strong>Alternate Phone no: </strong>
                          {accountDetails.alternate_contact_number}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div>
                          <strong>Billing Address: </strong>
                          {accountDetails.address?.bill_to_address} {/* Optional chaining to avoid errors */}
                        </div>
                        <div>
                          <strong>Shipping Address: </strong>
                          {accountDetails.address?.ship_to_address}
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="font-16">
                    To update your phone number and email address, Please contact your regional Account Manager or
                    <a
                      href="mailto:IndiaHSBooks@elsevier.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-auth="NotApplicable"
                      data-linkindex="5"
                    >
                      {" Health Science Team"}
                    </a>
                  </p>
                </div>
                <div id="address" className={nav.address ? "" : "collapse"}>
                  <h3>Address</h3>
                  <div className="accountDetails">
                    <h4>Billing Addresses</h4>
                    {Array.isArray(billingAddress) && billingAddress.length > 0 ? (
                      billingAddress.map((element, key) => (
                        <p className="font-16" key={key}>
                          Address {key + 1}
                          <br /> {element}
                        </p>
                      ))
                    ) : (
                      <p>No billing addresses available.</p>
                    )}
                    <h4>Shipping Addresses</h4>
                    {Array.isArray(shippingAddress) && shippingAddress.length > 0 ? (
                      shippingAddress.map((element, key) => (
                        <p className="font-16" key={key}>
                          Address {key + 1}
                          <br /> {element}
                        </p>
                      ))
                    ) : (
                      <p>No shipping addresses available.</p>
                    )}
                  </div>
                  <p className="font-16">
                    To update your phone number and email address, Please contact your regional Account Manager or
                    <a
                      href="mailto:IndiaHSBooks@elsevier.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-auth="NotApplicable"
                      data-linkindex="5"
                    >
                      {" Health Science Team"}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div >
        <Footer />
      </React.Fragment >
    );
  }
};

export default Account;